/**
 * Created by richardlovejoy on 2/13/17.
 */
import {m4} from '../../utils/math/m4';


const Camera = {

  position: {x: 0, y: 0, z: 32.203},
  rotation: {x: -6 * Math.PI/180, y: 0, z: 0},
  fov: 43.69,
  sceneScale: 1.25,
  viewMatrix: [
    1, 0, 0, 0,
    0, 0.9945218563079834, 0.10452845692634583, 0,
    0, -0.10452845692634583, 0.9945218563079834, 0,
    0, 3.366142988204956, -32.026710510253906, 1
  ],

  // this is based on 1024x675 viewport
  projectionMatrix: [
    1.6443202495574951, 0, 0, 0,
    0, 2.494494676589966, 0, 0,
    0, 0, -1.0020020008087158, -1,
    0, 0, -2.002002000808716, 0
  ],

  projectorFudge: {
    x: 0,
    y: 0
  },

  init(depthScale) {

    this.depthScale = depthScale;

    // probably should create this using position, rotation and fov... todo
    this.viewProjectionMatrix = m4.multiply(this.projectionMatrix, this.viewMatrix);
  },

  worldToScreen(worldVec, viewport, $screenVec) {

    let screenVec = (typeof $screenVec !== 'undefined') ? $screenVec : {};

    // multiply world position by view/projection
    var vpm = this.viewProjectionMatrix;
    m4.vectorMultiply(worldVec, vpm, screenVec);

    // calculate w co-coord
    var w = 1 *
      (worldVec.x * vpm[3] +
      worldVec.y * vpm[7] +
      worldVec.z * vpm[11] +
      1 * vpm[15]);

    var fudgex = this.projectorFudge.x * viewport.width/1024;
    var fudgey = this.projectorFudge.y * viewport.height/675;

    var cw = (viewport.width) * 0.5;
    var ch = (viewport.height) * 0.5;

    screenVec.x = cw + (screenVec.x / w) * cw * this.sceneScale + fudgex;
    screenVec.y = ch - (screenVec.y / w) * ch * this.sceneScale - fudgey;

    return screenVec;
  },

  scaleFromScreen(screenVec) {

    return 0.8*Math.max(0.1, (1-screenVec.z/this.depthScale));

  }

};

export default Camera;







// WEBPACK FOOTER //
// ./app/src/display/scene/Camera.js